module.exports = __webpack_public_path__ + "static/img/insulation-bag.4d19d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/insulation-bag.png
// module id = bU3v
// module chunks = 2